import React, { useEffect, useState } from "react";

import axios from "axios";
import { BASE_URL } from "./axios";
import { ToastContainer } from "react-toastify";
import { handleErrorToast } from "../../utils/ReusableFunctions";
import { SearchBig } from '../../utils/ReusableSVGs';

import Dashboardnavbar from "../../layout/Navbar/Navbar"

import {
    AddSiteDepartments, UpdateSiteDepartmentupdate, DeleteSiteDepartment
} from "./DepartmentCrud"

import "./Subcompany.css";
const SiteDepartmentTable = () => {

    const [buffer, setBuffering] = useState(true); //buffering logic

    const [DepartmentList, setDepartmentList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };



    const getSiteSubcompanies = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {



            const res = await axios.get(

                `${BASE_URL}/configuration/department/`

            );
            setDepartmentList(res.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSiteSubcompanies();
    }, []);




    return (
        <>

            {/* <Dashboardnavbar name={"Sub Company"} url="Sub Company" /> */}
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className='content-tabs'>
                <div class="attendance-subcont">
                    <div className="field-cont flex-row justify-between" style={{ width: "100%" }}>

                        <div className="field-cont-div">
                            <SearchBig />
                            <input
                                placeholder="Search Sub Department"
                                className="attendance-input-field "
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                            <hr className="field-cont-hr" />

                        </div>


                        <AddSiteDepartments getSiteSubcompanies={getSiteSubcompanies} />

                    </div>
                </div>

                <div className="table-css-white-background">
                    <div className="table-box  scroll-container-table" >
                        <table className="table-css">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text">Sr no.</th>
                                    <th className="table-heading-text">Department Name</th>
                                    <th className="table-heading-text">Sub Company</th>


                                    <th
                                        className="table-heading-text text-right"
                                    // style={{ padding: "30px 45px" }}
                                    >
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner-bgdatil"></div>//buffering logic
                            ) : (
                                <tbody>
                                    {DepartmentList
                                        ?.filter((e) =>
                                            e.title.toLowerCase().includes(searchQuery.toLowerCase())
                                        )
                                        .sort((a, b) =>
                                            a.title.localeCompare(b.title, "en", {
                                                ignorePunctuation: true,
                                            })
                                        )
                                        .map((i, index) => (
                                            <React.Fragment key={index}>


                                                <tr className="custom-table-head-td">


                                                    <td className="table-body">{index + 1}</td>
                                                    <td className="table-body">{i.title} </td>
                                                    <td className="table-body">{i.sub_company_title}</td>


                                                    <td className="table-body text-right" style={{ justifyContent: 'right' }}>
                                                        <UpdateSiteDepartmentupdate
                                                            i={i} designationId={i.id}
                                                            getSiteSubcompanies={getSiteSubcompanies}


                                                        />


                                                        <DeleteSiteDepartment
                                                            i={i}
                                                            getSiteSubcompanies={getSiteSubcompanies}
                                                        />

                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </div>
            </div>
        </>
    );
};

export default SiteDepartmentTable